module.exports = __webpack_public_path__ + "static/media/iconfinder_html5_395261.62035578.svg";